<template>
  <div class="q-pt-xl text-center">
    <p class="text-faded">Ressource leider nicht gefunden <strong>(404)</strong></p>
  </div>
</template>

<script>
export default {
  name: "Error404"
};
</script>
